var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistoricStaffReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.542 47.25V42.75C49.542 38.5564 46.6738 35.0326 42.792 34.0335M34.917 7.40421C38.2153 8.73933 40.542 11.9729 40.542 15.75C40.542 19.5271 38.2153 22.7607 34.917 24.0958M38.292 47.25C38.292 43.0565 38.292 40.9598 37.6069 39.3058C36.6935 37.1006 34.9414 35.3485 32.7361 34.4351C31.0822 33.75 28.9855 33.75 24.792 33.75H18.042C13.8485 33.75 11.7518 33.75 10.0978 34.4351C7.89259 35.3485 6.14052 37.1006 5.22708 39.3058C4.54199 40.9598 4.54199 43.0565 4.54199 47.25M30.417 15.75C30.417 20.7206 26.3876 24.75 21.417 24.75C16.4464 24.75 12.417 20.7206 12.417 15.75C12.417 10.7794 16.4464 6.75 21.417 6.75C26.3876 6.75 30.417 10.7794 30.417 15.75Z",
    stroke: "#278DEC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoricStaffReports);
export default __webpack_public_path__ + "static/media/HistoricStaffReports.c38e20c4565180c1cc80a5f174b489cc.svg";
export { ForwardRef as ReactComponent };